import { Typography } from "@material-tailwind/react";
import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const RedirectToApp = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const path = window.location.pathname;

  useEffect(() => {
    let deepLink = "";
    let webDeepLink = "";
    if (path.includes("invitation")) {
      const workspaceId = searchParams.get("workspaceId");
      const subWorkspaceId = searchParams.get("SubWorkSpaceId");
      const email = searchParams.get("Email");
      const lastJoinDate = searchParams.get("lastjoinDate");

      deepLink = `myapp://debatebase/invitation?workspaceId=${workspaceId}&SubWorkSpaceId=${subWorkspaceId}&Email=${email}&lastjoinDate=${lastJoinDate}`;
      webDeepLink = `/join?workspaceId=${workspaceId}&SubWorkSpaceId=${subWorkspaceId}&Email=${email}&lastjoinDate=${lastJoinDate}`;
    } else if (path.includes("sharedebates")) {
      const type = searchParams.get("type");
      const debateId = searchParams.get("debateId");
      const currentRound = searchParams.get("currentRound");
      const totalRound = searchParams.get("totalRound");

      deepLink = `myapp://debatebase/sharedebates?type=${type}&debateId=${debateId}&currentRound=${currentRound}&totalRound=${totalRound}`;
      webDeepLink = "/";
    } else if (path.includes("subscription")) {
      deepLink = `myapp://debatebase/subscription`;
      webDeepLink = "/?to=upgrade-plan?plan=/base-plan";
    }

    const androidStore = "https://play.google.com/store/apps/details?id=com.dev.debatebase";
    const iosStore = "https://apps.apple.com/us/app/debatebase/id1606227567";
    const userAgent = navigator.userAgent || navigator.vendor;

    const openApp = () => {
      // Detect the platform based on the user agent string
      const isIOS = /iPad|iPhone|iPod/.test(userAgent);
      const isAndroid = /android/i.test(userAgent);
    
      // Create a hidden <a> element dynamically
      const link = document.createElement("a");
      link.href = (isIOS || isAndroid) ? deepLink : webDeepLink; // Set the href to the custom deep link (e.g., myapp://debatebase/invitation?...)
      link.style.display = "none"; // Hide the link so it’s not visible to the user
      document.body.appendChild(link); // Add the link to the DOM
    
      // Simulate a user click on the hidden link
      link.click(); // This triggers the browser to process the href (myapp://...), attempting to open the app
    
      // Clean up by removing the link from the DOM
      document.body.removeChild(link);
    
      // Fallback logic: Handle cases where the app doesn’t open
      const startTime = Date.now(); // Record the time when the click is triggered
      setTimeout(() => {
        // After 10 seconds, check if the page is still active
        if (Date.now() - startTime < 11000) {
          // If less than 11000ms have passed, the page didn’t unload (app didn’t open)
          if (isAndroid) {
            window.location.href = androidStore; // Redirect to Play Store for Android
          } else if (isIOS) {
            window.location.href = iosStore; // Redirect to App Store for iOS
          } else {
            navigate(webDeepLink); // Fallback to web URL for other platforms
          }
        }
      }, 10000); // Wait 10 seconds before assuming the app didn’t open
    
      // Detect if the app opened successfully by monitoring page visibility
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
          // If the page becomes hidden, the app likely opened, so no fallback is needed
          clearTimeout(); // Attempt to clear the timeout (though this has a bug, explained below)
        }
      }, { once: true }); // Listener runs only once
    };
    
    // Call the function to execute the redirect
    openApp();
  }, [path, searchParams, navigate]);
  return (
    <section className="h-screen flex flex-col md:flex-row items-center justify-between p-8">
      <div className="flex flex-col justify-center items-center gap-4  w-full">
        <Typography variant="h1">Hello, Welcome to Debatebase</Typography>
        <h1>Redirecting you to the app...</h1>
        <p>
          If nothing happens, <a href="/">click here</a> to continue on the web.
        </p>
      </div>
    </section>
  );
};

export default RedirectToApp;
